import { GiftCardAssignOtherForm, ModalContent, ModalView } from 'components'

export interface GiftCardAssignOtherModalProps extends Record<string, unknown> {
  windowRef: React.RefObject<HTMLDivElement>
  giftCardId: number
}

const GiftCardAssignOther = ({
  windowRef,
  giftCardId,
}: GiftCardAssignOtherModalProps) => {
  return (
    <ModalView>
      <ModalContent
        title="Assign gift card to a friend"
        subtitle={
          <p>
            Enter the email address of the person to which you'd like to assign
            this gift card, and they'll receive an email with the gift card
            number so they can use it to make a purchase online.
          </p>
        }
      >
        <GiftCardAssignOtherForm
          windowRef={windowRef}
          giftCardId={giftCardId}
        />
      </ModalContent>
    </ModalView>
  )
}

export default GiftCardAssignOther
